import { render } from "./BaseMenuItem.vue?vue&type=template&id=7e337a03&ts=true"
import script from "./BaseMenuItem.vue?vue&type=script&lang=ts"
export * from "./BaseMenuItem.vue?vue&type=script&lang=ts"

import "./BaseMenuItem.vue?vue&type=style&index=0&id=7e337a03&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__